import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { selectUserState } from '@core/data-access/selectors/user.selectors';
import { Store } from '@ngrx/store';
import { first, map } from 'rxjs';

export const visitorGuard: CanMatchFn = () => {
  const store: Store = inject(Store);
  const router: Router = inject(Router);
  return store.select(selectUserState).pipe(
    first(),
    map((state) => !state?.user?.token || router.parseUrl('/admin'))
  );
};
